import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import PublicationCreator from '../../components/PublicationCreator';
import { PublicationSource } from './reducer';

const mapStateToProps = (state: StoreState) => {
	const {
		publicationCreator: {
			isDisplayed,
			source,
		},
	} = state;

	return {
		isDisplayed,
		isFromFile: source === PublicationSource.FILE,
	};
};

export default connect(mapStateToProps)(PublicationCreator);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/PublicationCreator/index.tsx